'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactBootstrap = require('react-bootstrap');

var _LabelledInputComponent = require('../input/LabelledInputComponent');

var _LabelledInputComponent2 = _interopRequireDefault(_LabelledInputComponent);

var _SubSectionHeaderComponent = require('./SubSectionHeaderComponent');

var _SubSectionHeaderComponent2 = _interopRequireDefault(_SubSectionHeaderComponent);

var _TextInputComponent = require('../input/TextInputComponent');

var _TextInputComponent2 = _interopRequireDefault(_TextInputComponent);

var _DatePickerComponent = require('../input/DatePickerComponent');

var _DatePickerComponent2 = _interopRequireDefault(_DatePickerComponent);

var _SelectComponent = require('../input/SelectComponent');

var _SelectComponent2 = _interopRequireDefault(_SelectComponent);

var _RadioGroupComponent = require('../input/RadioGroupComponent');

var _RadioGroupComponent2 = _interopRequireDefault(_RadioGroupComponent);

var _PropTypes = require('../../validators/common/PropTypes');

var _translate = require('../../language/translate');

var _commonFunctions = require('../../helpers/commonFunctions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Renders a single additional applicant component for the form.
 */
var ApplicantComponent = function ApplicantComponent(_ref) {
  var dynamicFieldIndex = _ref.dynamicFieldIndex,
      inputComponentField = _ref.inputComponentField,
      relationshipOptions = _ref.relationshipOptions,
      onChangeHook = _ref.onChangeHook,
      formValues = _ref.formValues,
      dates = _ref.dates,
      showNames = _ref.showNames,
      showSchoolDropdown = _ref.showSchoolDropdown,
      peCoverage = _ref.peCoverage,
      formConfig = _ref.formConfig,
      isTugo = _ref.isTugo,
      applicantOptions = _ref.applicantOptions,
      hintStatus = _ref.hintStatus;

  function printApplicantTitle(index) {
    if (applicantOptions && applicantOptions.headerLabel) {
      return applicantOptions.headerLabel;
    }
    return index === -1 ? 'Primary Applicant' : (0, _translate.t)('Applicant') + ' ' + (index + 2);
  }

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      _SubSectionHeaderComponent2.default,
      null,
      (0, _translate.t)(printApplicantTitle(dynamicFieldIndex))
    ),
    showNames && _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_LabelledInputComponent2.default, {
        inputId: 'additionalApplicantFirstName',
        inputLabel: formConfig.first_name.title,
        inputComponent: _TextInputComponent2.default,
        inputComponentField: inputComponentField.first_name
      }),
      _react2.default.createElement(_LabelledInputComponent2.default, {
        inputId: 'additionalApplicantLastName',
        inputLabel: formConfig.last_name.title,
        inputComponent: _TextInputComponent2.default,
        inputComponentField: inputComponentField.last_name
      })
    ),
    _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'additionalApplicantDob',
      inputLabel: formConfig.dob.title,
      inputComponent: _DatePickerComponent2.default,
      inputComponentField: inputComponentField.dob,
      inputComponentProps: {
        placeholderText: (0, _translate.t)('Please select a date...'),
        showYearDropdown: true,
        showMonthDropdown: true,
        minDate: dates.applicants.dob.min,
        maxDate: dates.applicants.dob.max,
        onChangeHook: onChangeHook
      },
      dynamicFieldIndex: dynamicFieldIndex
    }),
    showNames && !relationshipOptions && _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'additionalApplicantEmail',
      inputLabel: formConfig.email.title,
      inputComponent: _TextInputComponent2.default,
      inputComponentField: inputComponentField.email
    }),
    relationshipOptions && _react2.default.createElement(_LabelledInputComponent2.default, {
      hasExpandableHint: formConfig['additional_data.relationship_to_primary_applicant'].hint,
      expandableHintId: 'relationshipTypesHint',
      expandableHintTitle: '',
      expandableHintContent: formConfig['additional_data.relationship_to_primary_applicant'].hint,
      expandableHintIsRawHtml: true,
      inputId: 'additionalApplicantRelationship',
      inputLabel: formConfig['additional_data.relationship_to_primary_applicant'].title,
      inputComponent: _SelectComponent2.default,
      inputComponentField: inputComponentField.additional_data.relationship_to_primary_applicant,
      inputComponentProps: {
        options: formConfig['additional_data.relationship_to_primary_applicant'].options,
        onChangeHook: onChangeHook
      },
      dynamicFieldIndex: dynamicFieldIndex
    }),
    showSchoolDropdown && formValues.application.additional_data.school ? formValues.application.additional_data.school !== 'other' ? _react2.default.createElement(_LabelledInputComponent2.default, {
      hasExpandableHint: true,
      expandableHintId: 'applicantSchoolHint',
      expandableHintTitle: formConfig['applicant.additional_data.school'].label,
      expandableHintContent: formConfig['applicant.additional_data.school'].hint,
      inputLabel: formConfig['applicant.additional_data.school'].title,
      inputComponent: _SelectComponent2.default,
      inputComponentField: inputComponentField.additional_data.school,
      inputComponentProps: {
        options: formConfig['applicant.additional_data.schools'].options['' + (0, _commonFunctions.getSchoolCode)(formValues, formConfig)],
        onChangeHook: onChangeHook
      }
    }) : _react2.default.createElement(_LabelledInputComponent2.default, {
      hasExpandableHint: true,
      expandableHintId: 'applicantSchoolHint',
      expandableHintTitle: formConfig['applicant.additional_data.school'].label,
      expandableHintContent: formConfig['applicant.additional_data.school'].hint,
      inputLabel: formConfig['applicant.additional_data.school'].title,
      inputComponent: _reactBootstrap.FormControl.Static,
      inputComponentChildren: 'Other',
      isStatic: true
    }) : null,
    showSchoolDropdown && (formValues.application.additional_data.school === 'other' || inputComponentField.additional_data.school.value === 'other') && _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'applicantSchoolOther',
      inputLabel: formConfig['applicant.additional_data.school_other'].title,
      inputComponent: _TextInputComponent2.default,
      inputComponentField: inputComponentField.additional_data.school_other,
      inputComponentProps: {
        type: 'text',
        onChangeHook: onChangeHook
      }
    }),
    peCoverage && _react2.default.createElement(_LabelledInputComponent2.default, {
      hasExpandableHint: true,
      expandableHintId: 'peCoverageHint',
      hintStatus: hintStatus,
      expandableHintTitle: formConfig['applicant.additional_data.pe_coverage'].label,
      expandableHintContent: formConfig['applicant.additional_data.pe_coverage'].hint,
      inputId: 'additionalApplicantPeCoverage',
      inputLabel: formConfig['applicant.additional_data.pe_coverage'].title,
      inputComponent: _RadioGroupComponent2.default,
      inputComponentField: inputComponentField.additional_data.pe_coverage,
      inputComponentProps: {
        options: formConfig['applicant.additional_data.pe_coverage'].options,
        onChangeHook: onChangeHook,
        disabled: isTugo && formValues.application.additional_data.destination && formValues.application.additional_data.destination === 'CA'
      }
    })
  );
};

ApplicantComponent.propTypes = {
  dynamicFieldIndex: _react2.default.PropTypes.number.isRequired,
  inputComponentField: _react2.default.PropTypes.object.isRequired,
  relationshipOptions: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.bool, _PropTypes.INPUT_OPTIONS_STRUCTURE]),
  onChangeHook: _react2.default.PropTypes.func,
  formValues: _react2.default.PropTypes.object.isRequired,
  dates: _react2.default.PropTypes.object.isRequired,
  showNames: _react2.default.PropTypes.bool,
  peCoverage: _react2.default.PropTypes.bool,
  showSchoolDropdown: _react2.default.PropTypes.bool,
  formConfig: _react2.default.PropTypes.object,
  isTugo: _react2.default.PropTypes.bool,
  applicantOptions: _react2.default.PropTypes.object,
  hintStatus: _react2.default.PropTypes.bool
};

exports.default = ApplicantComponent;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/common/ApplicantComponent.jsx
// module id = 1658
// module chunks = 0